var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "1440",
      "persistent": "",
      "fullscreen": _vm.$vuetify.breakpoint.mobile
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', _vm._b({
    staticClass: "d-flex flex-column",
    attrs: {
      "light": "",
      "tile": _vm.$vuetify.breakpoint.mobile
    }
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-title', [_c('v-row', {
    staticClass: "ma-n2",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" 주문상세 ")]), _vm.hasConsoleScope && _vm.order.isManualMoneyIssueRequired ? [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "content-class": "rounded-lg pa-0 elevation-24"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('span', _vm._g(_vm._b({}, 'span', attrs, false), on), [_c('v-btn', {
          attrs: {
            "small": "",
            "color": "error"
          },
          on: {
            "click": _vm.issueMoney
          }
        }, [_vm._v(" 예치금 지급하기 ")])], 1)];
      }
    }], null, false, 3430886627)
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "rounded": "lg"
    }
  }, [_c('v-card-text', {
    staticClass: "caption",
    staticStyle: {
      "line-height": "2.4"
    }
  }, [_c('ul', [_c('li', [_vm._v("예치금이 발급되지 않은 구매확정 주문입니다.")]), _c('li', [_c('v-chip', {
    staticClass: "rounded-sm",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_c('span', [_vm._v(" 정산 ")])]), _c('v-icon', [_vm._v(" mdi-chevron-right ")]), _c('v-chip', {
    staticClass: "rounded-sm",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_c('span', [_vm._v(" 수수료 정책 ")])]), _vm._v(" 메뉴에서 "), _c('br'), _vm._v(" 해당 판매자 수수료 정책을 확인하신 뒤, "), _c('br'), _c('v-chip', {
    staticClass: "rounded-sm",
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_c('span', [_vm._v("예치금 지급하기")])]), _vm._v(" 버튼을 클릭해주세요. ")], 1)])])], 1)], 1)], 1)] : _vm._e(), _c('v-spacer'), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-icon', {
    on: {
      "click": function ($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v("mdi-close")])], 1)], 2)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "pt-3",
    staticStyle: {
      "flex": "1 0 auto",
      "overflow-y": "auto"
    }
  }, [_c('v-row', {
    staticClass: "mx-n2"
  }, [_c('v-col', {
    staticClass: "d-flex flex-column pa-2",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('order-view-baseinfo', _vm._b({}, 'order-view-baseinfo', {
    order: _vm.order
  }, false)), _c('order-view-receiver', _vm._b({
    staticClass: "mt-4"
  }, 'order-view-receiver', {
    order: _vm.order
  }, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('order-view-payment', _vm._b({}, 'order-view-payment', {
    order: _vm.order
  }, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-textarea', _vm._b({
    attrs: {
      "label": "메모",
      "color": "primary",
      "auto-grow": "",
      "rows": "9"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('v-btn', {
          staticClass: "mr-n2 mb-n2",
          attrs: {
            "absolute": "",
            "right": "",
            "bottom": "",
            "small": "",
            "text": "",
            "color": "primary"
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v(" 저장하기 ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.order.memo,
      callback: function ($$v) {
        _vm.$set(_vm.order, "memo", $$v);
      },
      expression: "order.memo"
    }
  }, 'v-textarea', _vm.attrs_input__console, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('order-view-purchases', _vm._b({}, 'order-view-purchases', _vm.order, false))], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }